package ui.app.assign.detail.definition

import androidx.compose.foundation.layout.*
import androidx.compose.material3.Card
import androidx.compose.material3.FloatingActionButton
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import api.ResourceType
import apps.App
import compose.assets.Svg
import compose.assets.svg.Cursor_pointer
import compose.assets.svg.Edit
import ssoft.frontend.generated.resources.*
import tools.GlobalObjectShare
import tools.rememberString
import ui.app.assign.detail.AppDetailScope
import ui.resource.ResourceListingArgs
import ui.widget.LazyImage
import ui.widget.Space


@Composable
fun AppDetailScope.AppDefOfPdf(
    wrapper: AppDetailScope.Wrapper,
    nnvl: AppDetailScope.WrapperDefinition.OfPdf
) {

    if (display.isMobile) {
        Column {
            DefaultFields(
                nnvl = wrapper,
                modifier = Modifier.fillMaxWidth(),
                mainContent = {
                    Space(8.dp)
                    PdfPicker(nnvl, wrapper, Modifier.fillMaxWidth())
                    Space(8.dp)
                    PagingMode(nnvl, wrapper, Modifier.fillMaxWidth())
                    Space(16.dp)
                })
        }
    } else {
        Row {
            Column(Modifier.weight(1F)) {
                DefaultFields(
                    nnvl = wrapper,
                    modifier = Modifier.fillMaxWidth()
                )
            }
            Space(16.dp)
            Column(Modifier.weight(1F)) {
                PdfPicker(
                    nnvl = nnvl,
                    wrapper = wrapper,
                    modifier = Modifier.fillMaxWidth()
                )
                Space(16.dp)
                PagingMode(nnvl, wrapper, Modifier.fillMaxWidth())
            }
        }
    }
    Space(64.dp)
}

@Composable
private fun AppDetailScope.PagingMode(
    nnvl: AppDetailScope.WrapperDefinition.OfPdf,
    wrapper: AppDetailScope.Wrapper,
    modifier: Modifier = Modifier.width(256.dp)
) {
    DropDownField(
        icon = Svg.Cursor_pointer,
        field = nnvl.pagingMode,
        label = Res.string.layer_bottom_detail__document_paging_label,
        variants = mapOf(
            App.Pdf.PagingMode.SCROLL.mask to Res.string.layer_bottom_detail__document_paging_scroll,
            App.Pdf.PagingMode.PAGE_FLIP.mask to Res.string.layer_bottom_detail__document_paging_page_flip,
        ),
        modifier = modifier,
        canEdit = wrapper.canEdit
    )
}

@Composable
private fun AppDetailScope.PdfPicker(
    nnvl: AppDetailScope.WrapperDefinition.OfPdf,
    wrapper: AppDetailScope.Wrapper,
    modifier: Modifier = Modifier.width(256.dp)
) {

    val imagePickerKey = remember(args.appId) {
        "PdfPicker:${args.appId}"
    }

    GlobalObjectShare.Consumer(imagePickerKey)

    Card(modifier) {
        Box {
            Column(Modifier.padding(16.dp)) {
                Text(Res.string.layer_bottom_detail__document_pick_label.rememberString())
                Space(8.dp)
                Card(Modifier.fillMaxWidth()) {
                    LazyImage(
                        id = nnvl.pdf.state,
                        modifier = Modifier.fillMaxWidth(),
                        contentScale = ContentScale.FillWidth
                    )
                }
            }
            if (wrapper.canEdit) {
                FloatingActionButton(
                    onClick = {
                        GlobalObjectShare.launchImagePicker(
                            key = imagePickerKey,
                            nav = nav,
                            args = ResourceListingArgs(
                                companyId = args.companyId,
                                restrictionType = ResourceType.DOCUMENT.mask,
                                restrictionCanIgnoreAspectRatio = true
                            )
                        ) {
                            it.firstOrNull()?.also { item ->
                                nnvl.pdf.set(item.id)
                            }
                        }
                    },
                    modifier = Modifier.align(Alignment.BottomEnd)
                ) {
                    Icon(
                        imageVector = Svg.Edit,
                        contentDescription = null
                    )
                }
            }
        }
    }
}

